module.exports = __webpack_public_path__ + "img/sv83on.fb7068f5.svg";